export default {
  title: 'Client portal',
  titlePrefix: '',
  ErrorTitle: 'Technical error',
  ErrorMessage: 'An error has occured. We apologize for the inconvenience.',
  ErrorRetryButton: 'Retry',
  NotFoundTitle: 'Page not found',
  NotFoundMessage: 'Sorry, the page may have been moved or deleted.',
  NotFoundBackButton: 'Back',
  copyright: `© ${new Date().getFullYear()} iA Private Wealth Inc. All rights reserved. iA Private Wealth is a trademark and business name under which iA Private Wealth Inc. operates.`,
  hrefLogoOcrcvm: 'https://www.ciro.ca/',
  altLogoOcrcvm: 'IIROC Logo',
  ocrcvm: 'The CIRO AdvisorReport',
  hrefOcrcvm: 'https://www.ciro.ca/office-investor/know-your-advisor-advisor-report',
  memberOfCanadian: 'Canadian Investor Protection Fund',
  hrefMemberOfCanadian: 'https://www.cipf.ca/',
  cssFooterLogoMargin: '3px 0 0 45px',
  cssFooterLogoWidth: '170px',
};
